import { useEffect, useState } from "react";
import { IconCards } from "./icons/IconCards";
import { IconCardsOutline } from "./icons/IconCardsOutline";
import usePersistentStore from "../lib/store/PersistentStore";
import { gridLevelDateKey } from "../lib/utils/gridLevels";
import { useLocale } from "../i18n/LocaleContext";

export function PromoBanner() {
  const { locale } = useLocale();
  const [cardMode, toggleCardMode] = usePersistentStore((state) => [
    state.cardMode,
    state.toggleCardMode,
  ]);

  const [selected, setSelected] = useState(false);

  useEffect(() => {
    if (cardMode) {
      setSelected(true);
    } else {
      setSelected(false);
    }
  }, [cardMode]);

  function toggleMode() {
    toggleCardMode();
  }

  // Promo copy is English only
  if (locale !== "en") {
    return null;
  }

  return (
    // <div className="w-screen bg-yellow-100 p-2 px-1 text-center text-sm text-gray-800 sm:text-sm md:p-3">
    //   📹 See who <a
    //     className="font-bold text-blue-600 underline dark:text-blue-400"
    //     href="https://twitter.com/PokegridGame/status/1742339799019839995"
    //     target="_blank"
    //   >
    //     Stremi TV
    //   </a> picked in his self-designed PokeGrid!
    // </div>
    <div className="w-screen bg-yellow-100 p-2 px-2 text-center text-sm text-gray-800 sm:text-sm md:p-3">
      Indigo Disk Pokémon, Z-A Megas & movesets updated! 🎉
    </div>
  );
}
